var _path, _path2, _path3, _g, _path4, _path5;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLocked = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83421 3.74003C7.80437 3.74003 6.73232 5.04061 6.73236 6.00626V10.6219C6.73236 11.6007 5.9292 12.3942 4.93845 12.3942C3.94769 12.3942 3.14453 11.6007 3.14453 10.6219V6.00641C3.14453 6.00638 3.14453 6.00643 3.14453 6.00641C3.14443 2.511 6.45627 0.195312 9.83421 0.195312C13.2121 0.195312 16.524 2.51095 16.524 6.00633V10.6219C16.524 11.6007 15.7208 12.3942 14.7301 12.3942C13.7393 12.3942 12.9361 11.6007 12.9361 10.6219V6.00633C12.9361 5.04062 11.864 3.74003 9.83421 3.74003Z",
    fill: "#455964"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1018 12.187V21.6484C18.1018 22.8382 17.1496 23.8042 15.9768 23.8042H3.69919C2.52642 23.8042 1.57422 22.8382 1.57422 21.6484V12.187C1.57422 10.9972 2.52642 10.0312 3.69919 10.0312H15.9768C17.1496 10.0312 18.1018 10.9972 18.1018 12.187Z",
    fill: "#FFC107"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3758_107450",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 10,
    width: 8,
    height: 14
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67297 10.0312L0 23.8042H2.80378L7.47675 10.0312H4.67297Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3758_107450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1018 12.187V21.6484C18.1018 22.8382 17.1496 23.8042 15.9768 23.8042H3.69919C2.52642 23.8042 1.57422 22.8382 1.57422 21.6484V12.187C1.57422 10.9972 2.52642 10.0312 3.69919 10.0312H15.9768C17.1496 10.0312 18.1018 10.9972 18.1018 12.187Z",
    fill: "#FFD55C"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67134 17.4932L8.26695 20.4342C8.22642 20.7218 8.4258 20.9879 8.71222 21.0286C8.73651 21.0321 8.761 21.0338 8.78554 21.0338H10.8808C11.17 21.0368 11.4069 20.8036 11.4098 20.5132C11.4101 20.4864 11.4083 20.4597 11.4045 20.4332L11.0001 17.4922L8.67134 17.4932Z",
    fill: "#455964"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1987 15.533C12.1987 16.837 11.1416 17.894 9.83764 17.894C8.53364 17.894 7.47656 16.837 7.47656 15.533C7.47656 14.229 8.53364 13.1719 9.83764 13.1719C11.1416 13.1719 12.1987 14.229 12.1987 15.533Z",
    fill: "#455964"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLocked, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Locked.665e25b4.svg";
export { ForwardRef as ReactComponent };